<template>
    <v-btn ref="download-image-button"
           v-tippy="{placement: 'left'}"
           content="Save Image"
           :disabled="!image"
           @click="onClick"
    >
        <v-icon class="material-symbols-outlined">file_save</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    mounted() {
        this.$root.$refs.downloadImageButton = this.$refs["download-image-button"];
    },
    computed: {
        ...mapState("Projects", ['image']),
        ...mapState("UI", ['startTips']),
    },
    methods: {
        onClick() {
            // if (this.startTips == 5) this.$store.dispatch('UI/setStartTips', 'completed');

            this.$store.dispatch('UI/setRightColumn', 'download-image')
        }
    }
}
</script>